export default __webpack_public_path__ + "static/media/crew-mark.c2b40b05.svg";